import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section id="comprar" className="py-24 px-4 bg-gradient-to-t from-[#0c1425] to-[#111c35] relative overflow-hidden" data-id="element-30">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-31"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-33">
          <h2 className="text-3xl md:text-5xl font-serif text-cream leading-tight" data-id="element-34">
            Noches en Paz: <br data-id="element-35" />
            <span className="text-amber-200 text-2xl md:text-4xl" data-id="element-36">
              Reset de Sueño del Bebé en 7 Días (sin llorar)
            </span>
          </h2>

          <p className="text-xl text-amber-100/70 max-w-2xl mx-auto" data-id="element-37">
            Porque cuando estás desesperada, no necesitas otra suscripción.
            Necesitas un plan hoy.
          </p>

          <div className="py-8" data-id="element-38">
            <p className="text-2xl font-serif italic text-amber-400 mb-8" data-id="element-39">
              "Si tu noche te está rompiendo, empieza con el tablero."
            </p>

            {/* Price Display */}
            <div className="mb-8" data-id="element-40">
              <p className="text-amber-200/50 text-sm uppercase tracking-widest mb-3" data-id="element-41">
                Por tiempo limitado
              </p>
              <div className="flex items-center justify-center gap-3" data-id="element-42">
                <span className="text-2xl text-amber-200/40 line-through decoration-red-400/60 decoration-2" data-id="element-43">
                  $19.99
                </span>
                <span className="text-5xl md:text-6xl font-bold text-amber-400" data-id="element-44">
                  $6.39
                </span>
                <span className="text-lg text-amber-200/50" data-id="element-45">USD</span>
              </div>
              <p className="mt-2 text-emerald-400/80 text-sm font-medium" data-id="element-46">
                Ahorra 68% — precio de lanzamiento
              </p>
            </div>

            <motion.a href="https://maternidadenequilibrio.com/cart/48785580720352:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'Noches en Paz',
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="btn-gold inline-block px-10 py-5 text-xl font-bold rounded-full shadow-[0_0_30px_rgba(245,158,11,0.3)]" data-id="element-47">
              Descarga Noches en Paz — por solo $6.39
            </motion.a>

            <p className="mt-6 text-amber-200/50 text-sm" data-id="element-48">
              y esta misma noche aplica el Día 1 (ambiente + ritual + bitácora).
            </p>
          </div>

          <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-500/30 to-transparent mx-auto mt-12" data-id="element-49"></div>
        </motion.div>
      </div>
    </section>;
}